import { ProjectModel } from "./project.model";

export class ExportPackageModel{
    public project: ProjectModel

    constructor(project: ProjectModel) {
        if (project !== undefined)
            {
                this.project = project;
            }
    }
}